import programIcon from 'src/public/img/cbt-dashboard-icon.svg';

import { ProgramEnum, ProgramWeekEnum } from '../../models/programs';
import { weekEightData } from '../weekEight/models/weekEightData';
import { weekFiveData } from '../weekFive/models/weekFiveData';
import { weekFourData } from '../weekFour/models/weekFourData';
import { weekOneData } from '../weekOne/models/weekOneData';
import { weekSevenData } from '../weekSeven/models/weekSevenData';
import { weekSixData } from '../weekSix/models/weekSixData';
import { weekThreeData } from '../weekThree/models/weekThreeData';
import { weekTwoData } from '../weekTwo/models/weekTwoData';
import { CBTProgramState, CBTProgramWeek } from './cbtProgram';

export const cbtProgramWeeksData: CBTProgramWeek[] = [
    weekOneData,
    weekTwoData,
    weekThreeData,
    weekFourData,
    weekFiveData,
    weekSixData,
    weekSevenData,
    weekEightData,
];

export const initialFeedbackData = Object.values(ProgramWeekEnum).map(weekId => ({
    weekId,
    rating: 0,
    content: '',
}));

export const cbtProgramDefaultState: CBTProgramState = {
    id: ProgramEnum.CBT,
    title: 'Uplift: CBT for Depression and Anxiety',
    iconUrl: programIcon,
    weeks: cbtProgramWeeksData,
};
